import { useEffect, useState } from "react";
import { Bell, CheckCheck } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data.items || []);
      setUnread(data.unread || 0);
    } catch (e) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.debug("notifications load failed:", e?.message);
      }
    }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (o) load(); if (o && unread > 0) markAll(); }}>
      <PopoverTrigger asChild>
        <button
          data-testid="notif-bell"
          className="relative rounded-lg border border-slate-700 hover:bg-slate-800 p-2 text-slate-200 transition-colors"
          aria-label="Notifikasi"
        >
          <Bell className="h-4 w-4" />
          {unread > 0 && (
            <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center px-1">
              {unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent side="top" align="end" className="w-80 p-0 bg-white border-slate-200">
        <div className="flex items-center justify-between p-3 border-b border-slate-100">
          <div className="font-heading text-sm font-bold tracking-tight text-slate-900">Notifikasi</div>
          <Button variant="ghost" size="sm" onClick={markAll} className="h-7 text-xs">
            <CheckCheck className="h-3.5 w-3.5 mr-1" /> Tandai dibaca
          </Button>
        </div>
        <div className="max-h-80 overflow-y-auto app-scroll">
          {items.length === 0 ? (
            <div className="p-6 text-center text-sm text-slate-400">Belum ada notifikasi</div>
          ) : items.map((n) => (
            <div key={n.id} className={`px-4 py-3 border-b border-slate-100 ${n.is_read ? "" : "bg-emerald-50/40"}`}>
              <div className="flex items-start gap-2">
                <div className={`h-2 w-2 rounded-full mt-1.5 ${n.level === "danger" ? "bg-rose-500" : "bg-amber-500"}`} />
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-semibold text-slate-900">{n.title}</div>
                  <div className="text-xs text-slate-600 mt-0.5">{n.message}</div>
                  <div className="text-[11px] text-slate-400 mt-1">{new Date(n.created_at).toLocaleString("id-ID")}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
